/**
 * 社会车出入记录
 */
import React from "react";

import {Input, Row, Col, Icon, Tooltip, Select, DatePicker } from "antd";
import moment from "moment";
import http from "../../axios/http";
import PageLayout from "../ui/PageLayout";
import BarrierImage from "./BarrierImage";

//加载中遮罩
import Loading from '../ui/Loading';
class SocialParkLog extends React.Component {
  columns = [
    {
      title: "道闸时间",
      dataIndex: "bizTime",
      width: "10%",
    },
    {
      title: "业务完成时间",
      dataIndex: "insertTime",
      width: "10%",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "10%",
      render: (text, record, index) => (
        <div>
          {text}
          <Tooltip title="照片">
            <Icon
              type="picture"
              theme="filled"
              title="照片"
              className="table-operate-icon"
              onClick={this.doShowPhoto.bind(this, record)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "道闸号",
      dataIndex: "gateName",
      width: "10%",
    },
    {
      title: "状态",
      dataIndex: "stateStr",
      width: "10%",
    },
    {
      title: "扫码信息",
      dataIndex: "rid",
      width: "10%",
      render: (text, record, index) => <div>{this.getBizLogInfo(record)}</div>,
    },
  ];

  state = {
    loadData: "",
    showPhoto: false,
    editData: {},
    queryData: { zone: "" },
    parkZones: [],
    startDateStr: "",
    endDateStr: "",
  };

  onStartChange = (item, val) => {
    let queryData = this.state.queryData;
    queryData["startDateStr"] = val;
    this.setState({ startDateStr: val, queryData });
    this.state.loadData(queryData);
  };

  onEndChange = (item, val) => {
    let queryData = this.state.queryData;
    queryData["endDateStr"] = val;
    this.setState({ endDateStr: val });
    this.state.loadData(queryData);
  };

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadAllZone();
  }
  inputSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["plateNo"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  getBizLogInfo = (record) => {
    if (!record.bizLog) {
    } else {
      return (
        <Tooltip title={this.getBizLogStr(record)}>
          <Icon
            type={this.getBizLogIconType(record)}
            theme="filled"
            className="table-operate-icon"
          />
        </Tooltip>
      );
    }
  };

  getBizLogStr = (record) => {
    return (
      <div>
        {record.bizLog && <div>扫码结果: {record.bizLog.stateStr}</div>}
        {record.bizLog && record.bizLog.memberName && (
          <div>商户: {record.bizLog.memberName}</div>
        )}
        {record.bizLog && record.bizLog.vin && record.bizLog.vin.length > 1 && (
          <div>vin: {record.bizLog.vin}</div>
        )}
        {record.bizLog &&
          record.bizLog.state !== 200 &&
          record.bizLog.plateNo > 1 && (
            <div>登记车牌号: {record.bizLog.plateNo}</div>
          )}
      </div>
    );
  };

  getBizLogIconType = (record) => {
    switch (record.bizLog.state) {
      case 200:
        return "check-circle";
      default:
        return "stop";
    }
  };

  zoneChange = (val) => {
    console.log("zoneChange", val);
    let queryData = this.state.queryData;
    queryData["zone"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  doShowPhoto = (info, e) => {
    this.setState({ editData: info });
    this.setState({ showPhoto: true });
  };

  hidePhoto = () => {
    this.setState({ showPhoto: false });
  };

  render() {
    var { parkZones, queryData } = this.state;
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={20}>
                <Input.Search
                  placeholder="车牌号"
                  onSearch={this.inputSearch}
                  enterButton
                  style={{ width: "200px" }}
                />
                &nbsp;
                <Select
                  value={queryData.zone}
                  onChange={this.zoneChange}
                  style={{ width: "100px" }}
                >
                  <Select.Option value="">全部</Select.Option>
                  {parkZones &&
                    parkZones.map((item, index) => (
                      <Select.Option key={item.id} value={item.code}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
                &nbsp;
                <DatePicker
                  showTime
                  value={moment(this.state.startDateStr, "YYYY-MM-DD HH:mm")}
                  format="YYYY-MM-DD HH:mm"
                  onChange={this.onStartChange}
                  placeholder="起始时间"
                />
                ~
                <DatePicker
                  showTime
                  value={moment(this.state.endDateStr, "YYYY-MM-DD HH:mm")}
                  format="YYYY-MM-DD HH:mm"
                  onChange={this.onEndChange}
                  placeholder="结束时间"
                />
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/sociallog/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <BarrierImage
          visible={this.state.showPhoto}
          onCancel={this.hidePhoto.bind(this)}
          editData={this.state.editData}
        />
        <Loading
            visible={this.state.loadingVisible}
            message="数据加载中"
        />
      </div>
    );
  }
}

export default SocialParkLog;
